// extracted by mini-css-extract-plugin
export default {"privacyDiv":"PrivacyPolicy_privacyDiv__3iLVY"};